import { defineMessages } from '@jutro/locale';

export default defineMessages({
    policy: {
        id: 'ml.gateway.legacyPolicySummaryDetails.Policy',
        defaultMessage: '{lob} Policy'
    },
    policyNumber: {
        id: 'ml.gateway.legacyPolicySummaryDetails.PolicyNumber',
        defaultMessage: '#{number}'
    },
    ars: {
        id: 'ml.gateway.legacyPolicySummaryDetails.ARS',
        defaultMessage: 'ARS'
    },
    view: {
        id: 'ml.gateway.legacyPolicySummaryDetails.View',
        defaultMessage: 'View'
    },
    status: {
        id: 'ml.gateway.legacyPolicySummaryDetails.Status',
        defaultMessage: 'Status:'
    },
    effectiveDate: {
        id: 'ml.gateway.legacyPolicySummaryDetails.Effective Date',
        defaultMessage: 'Effective Date: {date}'
    },
    expirationDate: {
        id: 'ml.gateway.legacyPolicySummaryDetails.Expiration Date',
        defaultMessage: 'Expiration Date: {date}'
    }
});